import $ from 'jquery';
import { helpers } from '@bingads-webui/projection-grid-toolbar';

const headerRefreshCache = 'x-ms-refreshcampaigncache';

export function getConfig({
  gridName,
  startDate,
  endDate,
  columns,
  isForVNext,
  view,
  reportName,
  viewport,
  customHeaderOffset,
  customDataSource,
  filterService,
  appConfig,
}) {
  const headRows = isForVNext
    ? ['column-header-rows'] : helpers.singleToolbarHeadRows();
  const entitySet = customDataSource ? null : view.getCurrentEntityFromEdm()['Default.DimensionReport'].$call({
    Locale: 1,
    ReportType: `Enum.DimensionReportType'${reportName}'`,
  });

  const dataSource = customDataSource || {
    type: 'jsdata',
    entity: view.entity,
    primaryKey: 'Id',
    options: {
      entitySet,
      cacheResponse: false,
      headers: {
        [headerRefreshCache]: true,
      },
      afterFindAll: view.afterFindAllCallback.bind(view),
    },
    query: {
      startDate,
      endDate,
    },
  };

  const gridConfig = {
    name: gridName,
    tableClasses: ['table', 'table-bordered'],
    dataSource,
    rows: {
      headRows,
    },
    columns,
    scrolling: {
      header: {
        type: 'sticky',
        offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
      },
      virtualized: true,
    },
    filterService,
    config: appConfig,
  };

  if (viewport) {
    gridConfig.scrolling.viewport = viewport;
  }

  return gridConfig;
}
